import React from 'react';

const brands = [
  'Mercedes-Benz', 'BMW', 'Audi', 'Porsche', 'Range Rover',
  'Lexus', 'Bentley', 'Rolls-Royce', 'Ferrari', 'Lamborghini',
];

const BrandMarquee = () => {
  const items = [...brands, ...brands];

  return (
    <div className="relative py-8 bg-black border-y border-white/5 overflow-hidden">
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-black to-transparent z-10" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-black to-transparent z-10" />
      <div className="marquee-track flex items-center gap-12 whitespace-nowrap">
        {items.map((brand, i) => (
          <span
            key={`${brand}-${i}`}
            className="text-gray-500 font-display text-lg sm:text-xl tracking-widest uppercase hover:text-[#3DED97] transition-colors duration-300"
          >
            {brand}
          </span>
        ))}
      </div>
    </div>
  );
};

export default BrandMarquee;
